//
//
//
//
//
//
//
//
//


import isNil from "lodash.isnil";
import isEmpty from "lodash.isempty";

export default {

    name: 'EncodedMailto',

    props: {
        mail: {
            type: String,
            required: true
        },
        subject: {
            type: String,
            default: ''
        },
        body: {
            type: String,
            default: ''
        },
    },

    computed: {

      notEmpty() {

        if(isNil(this.mail) || isEmpty(this.mail)) {
          return false
        }

        return true

      },

        encoded() {
            const buf = []
            for (let i = this.mail.length - 1; i >= 0; i--) {
                buf.unshift(['&#', this.mail.charCodeAt(i), ';'].join(''))
            }
            return buf.join('')
        }

    },

    methods: {

        mailtoHandler(e) {
            this.emitEvent(this.mail)
            e.preventDefault()
            window.location.href =
                'mailto:' +
                this.mail +
                '?subject=' +
                encodeURIComponent(this.subject) +
                '&body=' +
                encodeURIComponent(this.body)
        },

        emitEvent(email) {
            this.$bus.$emit('track/mailto', email)
        }

    }
}
